import { MACRO_KEY } from "../../../defaults";

export const checkForWarnings = ({ macro, data }) => {
  if (macro === MACRO_KEY.CARDS)
    return !data.every((card) => !!card.card.link.link);
  if (macro === MACRO_KEY.ANNOUNCEMENTS)
    return !data.data.every((announcement) => !!announcement.url?.link);
  if (macro === MACRO_KEY.BUTTON || macro === MACRO_KEY.BUTTON_INLINE)
    return !data.url;

  return false;
};
